module.exports = __webpack_public_path__ + "media/images/benefit-03-aa42cb507887f25d87f9e85a955ce36c.svg";